import React, { useContext, useState } from 'react'
import ModelDialogWrappingII from '../../../../dialogModelUnit/ModelDialogWrappingII'
import ContractsNotifsDialogRight from '../../../../notificationsSystem/NotificationsComponents/ContractsNotificationsComponents/ContractsNotifsDialogRight'
import CustomCircularProgress from '../../../../smallComponents/CustomCircularProgress'
import { SettingsContext } from '../../../../../context/SettingsContext/SettingsContext'

const MDealsNotifDialog = ({
  isNotificationDialogOpen,
  notificationDialogClose,
  notification,
  pageProps,
  DialogCloser,
}) => {
  const { dealsNotificationsSenders, dealsNotificationsProjects } = pageProps
  const { settings } = useContext(SettingsContext)
  const [isDarkModeActive, setIsDarkModeActive] = useState(
    settings?.Mode === 'Dark'
  )
  const sender = dealsNotificationsSenders?.find(
    (se) => se._id === notification?.accompaniedData?.senderId
  )
  const project = dealsNotificationsProjects?.find(
    (pro) => pro._id === notification?.accompaniedData.projectId
  )
  return (
    <ModelDialogWrappingII
      isDarkModeActive={isDarkModeActive}
      setIsDarkModeActive={setIsDarkModeActive}
      dialogsArray={[
        {
          title: '',
          closeFun: () => notificationDialogClose(),
          open: isNotificationDialogOpen,
          content: sender ? (
            <ContractsNotifsDialogRight
              notifProps={{
                isDarkModeActive,
                notification,
                sender,
                project,
                notificationCardDialogClose: notificationDialogClose,
                DialogCloser,
                ...pageProps,
              }}
            />
          ) : (
            <CustomCircularProgress />
          ),
        },
      ]}
      mdialogMargins={'auto -24px auto -24px'}
    />
  )
}

export default MDealsNotifDialog
